/**
 * 交換スケジュールページ用のスクリプト
 */
if (is_route('replacement_schedule.index')) {
    // スクリプト読込
    require('./Base/replacement_schedule_base.index');

    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        replacement_schedule_base_event_set();
        replacement_schedule_base_setting_event_set();
    });
}